import { DashboardLayout } from "@/components/dashboard-layout";
import { createFileRoute, Outlet, useMatches } from "@tanstack/react-router";
import { Aperture, FileCog, Route as RouteIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import { CardContent } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { organisationsQueryOptions } from "@/server/organisations";
import { queuesQueryOptions } from "@/server/queues";
import { SubmenuItem } from "@/components/submenu";
import { useMemo } from "react";

export const Route = createFileRoute("/_dashboard/callscreening")({
  component: RouteComponent,
  beforeLoad: () => ({
    title: "Callscreening",
  }),
  loader: async () => {
    return {
      crumb: "Callscreening",
    };
  },
});

function RouteComponent() {
  const matches = useMatches();
  const hasChildRoute = matches[matches.length - 1].fullPath !== "/callscreening";

  const organisationsQuery = useQuery(organisationsQueryOptions());
  const organisations = organisationsQuery.data || [];
  const queuesQuery = useQuery(queuesQueryOptions);
  const queues = queuesQuery.data || [];

  const submenuItems: SubmenuItem[] = useMemo(
    //TODO: Change ids?
    () => [
      {
        id: 1,
        name: "System",
        href: "/callscreening/system",
        icon: <FileCog className="h-4 w-4" />,
        isParent: false,
      },
      {
        id: 2,
        name: "Organisations",
        href: "/callscreening/organisations",
        icon: <Aperture className="h-4 w-4" />,
        isParent: true,
        children: organisations?.map((organisation) => ({
          id: organisation.id,
          name: organisation.name,
          href: `/callscreening/organisations/${organisation.id}`,
        })),
      },
      {
        id: 3,
        name: "Queues",
        href: "/callscreening/queues",
        icon: <RouteIcon className="h-4 w-4" />,
        isParent: true,
        children: queues?.map((queue) => ({
          id: queue.id,
          name: queue.name,
          href: `/callscreening/queues/${queue.id}`,
        })),
      },
    ],
    [organisations, queues]
  );

  return (
    <DashboardLayout
      submenu={{
        items: submenuItems || [],
        title: "Callscreening",
        active: true,
        placeholder: "Search resources...",
      }}
    >
      {!hasChildRoute ? (
        <Card>
          <CardContent>
            <p className="text-md pb-20 pt-15 text-center">
              Please select a callscreening resource from the submenu to view its details or manage it.
            </p>
          </CardContent>
        </Card>
      ) : (
        <Outlet />
      )}
    </DashboardLayout>
  );
}
